import { render, staticRenderFns } from "./ocrRecognitionSetting.vue?vue&type=template&id=f3f4af7c&"
import script from "./ocrRecognitionSetting.vue?vue&type=script&lang=js&"
export * from "./ocrRecognitionSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3f4af7c')) {
      api.createRecord('f3f4af7c', component.options)
    } else {
      api.reload('f3f4af7c', component.options)
    }
    module.hot.accept("./ocrRecognitionSetting.vue?vue&type=template&id=f3f4af7c&", function () {
      api.rerender('f3f4af7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/ocrRecognitionSetting.vue"
export default component.exports